import {
	fetchLeaderboard,
	fetchLeaderboardFailed,
	fetchLeaderboardSuccess,
	fetchLeaderProfileFailed,
	fetchLeaderProfileSuccess,
	clearFetchedPagesLeaderboards,
	showUpdateNotice,
	type fetchLeaderProfile
} from "modules/actions/leaderboards";
import {call} from "typed-redux-saga/macro";
import Api from "modules/utils/Api";
import ApiError from "modules/utils/Api/ApiError";
import {select, put} from "typed-redux-saga";
import {
	getSentryUser,
	getLeaderboard,
	getLastLeaderboardPayload,
	getIsLoadedLeaderboards,
} from "modules/selectors";
import {captureSentryError} from "modules/utils/sentry";
import {globalError} from "modules/actions";
import {LeaderboardsTabsType} from "modules/enums";
import {getYesterdayCompletedRound} from "modules/selectors/rounds";

export const fetchLeaderboardsSaga = function* (action: ReturnType<typeof fetchLeaderboard>) {
	try {
		const storeRanks = yield* select(getLeaderboard);
		const lastCompletedRound = yield* select(getYesterdayCompletedRound);
		const rankType = action.payload.ranksType;

		const {haveToClear, isPrevLeaderboard, ...payload}: (typeof action)["payload"] =
			rankType === LeaderboardsTabsType.YESTERDAY
				? {
						...action.payload,
						ranksType: LeaderboardsTabsType.ACTIVE_STREAK,
						roundId: lastCompletedRound?.id,
						season: undefined,
				  }
				: action.payload;

		const response = yield* call(Api.Rank.leaderboard, payload);

		ApiError.CHECK(response.data);
		yield* put(
			fetchLeaderboardSuccess({
				...response.data.success,
				ranks: haveToClear
					? response.data.success.ranks
					// eslint-disable-next-line sonarjs/no-nested-conditional
					: isPrevLeaderboard
					? [...response.data.success.ranks, ...storeRanks.ranks]
					: [...storeRanks.ranks, ...response.data.success.ranks],

				nextPage: isPrevLeaderboard ? storeRanks.nextPage : response.data.success.nextPage,
			})
		);
	} catch (e) {
		const user = yield* select(getSentryUser);
		captureSentryError("fetchLeaderboardsSaga", "none", e, user);
		yield* put(globalError(e));
		yield* put(fetchLeaderboardFailed());
	}
};

export const fetchLiveLeaderboard = function* () {
	const payload = yield* select(getLastLeaderboardPayload);
	const isLoaded = yield* select(getIsLoadedLeaderboards);

	if (payload && isLoaded) {
		yield* put(clearFetchedPagesLeaderboards());
		yield* put(
			fetchLeaderboard({
				...payload,
				haveToClear: true,
			})
		);

		yield* put(showUpdateNotice(true));
	}
};

export const fetchLeaderProfileSaga = function* (action: ReturnType<typeof fetchLeaderProfile>) {
	try {
		const response = yield* call(Api.Rank.profile, action.payload);
		ApiError.CHECK(response.data);

		yield* put(fetchLeaderProfileSuccess(response.data.success));
	} catch (e) {
		const user = yield* select(getSentryUser);
		captureSentryError("fetchLeaderProfileSaga", "none", e, user);
		yield* put(globalError(e));
		yield* put(fetchLeaderProfileFailed());
	}
};
